/**
 * Return a `number` for a value that is either an integer or string representation
 * of an integer. If it is not an integer return `undefined`.
 */
const coerceInteger = (
  value: string | number | undefined | null,
): number | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (Number.isInteger(value)) {
    return value as number;
  }

  if (typeof value === "string" && /^\d+$/.test(value)) {
    return Number(value);
  }

  return undefined;
};

export { coerceInteger };
